interface ResponseFormatDisplayProps {
  responseFormatString: string
}

export const ResponseFormatDisplay = ({
  responseFormatString,
}: ResponseFormatDisplayProps) => {
  if (!responseFormatString) return null

  return (
    <div className="mb-4">
      <label htmlFor="response_format" className="block mb-2">
        <strong>
          Response Format <span className="text-gray-400">(Read-Only)</span>
        </strong>
      </label>
      <pre
        id="response_format"
        className="!w-full px-4 py-2 tc-mv-question-field rounded-2xl outline-none overflow-auto text-md whitespace-pre-wrap !resize-y no-scrollbar h-[120px]"
      >
        <code className="language-json text-green-400">
          {responseFormatString}
        </code>
      </pre>
    </div>
  )
}
